<template>
  <router-view></router-view>
</template>

<script setup>
import { onMounted } from 'vue'
onMounted(() => {
  console.log("挂载了");
})

</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body {
  overflow-x: hidden;
}
body::selection {
  color: #ffffff;
  background-color: #e84893;
  text-shadow: none;
}

#app::-webkit-scrollbar-thumb {
  background: #e84893;
  color: #e84893;
}

body {
  /* cursor: url(./assets/img/cursor.gif); */
}
</style>
